import React from "react";
import { FOOTER_NAV, SIGNUP_URL } from "../siteConfig";
import { IconArrowRight } from "./Icons";
import "../styles/footer.css";

const SiteFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ftr" aria-label="Footer">
      <div className="u-container">
        {/* Closing CTA, folded into the footer so the page ends on an action */}
        <div className="ftr__cta">
          <div className="ftr__cta-copy">
            <h2 className="t-h2">
              Everything you need,
              <br />
              <span className="t-grad">brought to you.</span>
            </h2>
            <p className="t-lead">
              Food, groceries, pharmacy runs, and Pasugo errands — one account,
              one app.
            </p>
          </div>
          <div className="ftr__cta-actions">
            <a className="btn btn--light btn--lg" href={SIGNUP_URL}>
              Create account
              <IconArrowRight size={18} className="btn__icon btn__icon--arrow" />
            </a>
            <a className="btn btn--outline-light btn--lg" href="/download">
              Get the app
            </a>
          </div>
        </div>

        <div className="ftr__main">
          <div className="ftr__brand">
            <a href="/" aria-label="PABS — home">
              <img
                className="ftr__logo"
                src="/pabs-wordmark-white.png"
                alt="PABS"
                width={104}
                height={62}
                loading="lazy"
              />
            </a>
            <p className="ftr__tagline">
              <strong>PABS</strong> (<em>Pickup And Bring Stuff</em>) — an
              all-in-one app for deliveries, errands, and rides in the Philippines.
            </p>
          </div>

          <nav className="ftr__cols" aria-label="Footer navigation">
            {FOOTER_NAV.map((col) => (
              <div className="ftr__col" key={col.title}>
                <h3 className="ftr__col-title">{col.title}</h3>
                <ul>
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className="ftr__base">
          <span>© {year} PABS. All rights reserved.</span>
          <span className="ftr__base-sep" aria-hidden="true" />
          <span>Serving the Philippines</span>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
